export default __webpack_public_path__ + "static/media/item-info.b002ced8.svg";